'use client'

import { type AxiosError } from 'axios'
import useSwr, { type SWRResponse } from 'swr'

import {
  type GetOrdersResponseV1,
  type MiraklControllerV1ApiBullyMiraklOrdersRequest,
  MiraklControllerV1ApiFactory,
} from '@redteclab/api/clients/bully'

import { useGlooApi } from '../../api'

const SWR_KEY = 'userOrdersMiraklGet'

const getSwrKey = (commercialOrderIds: string): string => {
  return `${SWR_KEY}_${commercialOrderIds}`
}

export const useApiOrdersSwrGetMiraklOrders = (options: {
  commercialOrderIds: string[]
}): SWRResponse<GetOrdersResponseV1[], AxiosError> => {
  const client = useGlooApi(MiraklControllerV1ApiFactory)

  const commercialOrderIds = options.commercialOrderIds
    .map((id) => id.trim())
    .filter(Boolean)
    .toSorted((leftOrderId, rightOrderId) =>
      leftOrderId.localeCompare(rightOrderId),
    )
    .join(',')

  const shouldFetchOrders = commercialOrderIds.length > 0

  const requestParameters: MiraklControllerV1ApiBullyMiraklOrdersRequest = {
    commercialOrderIds,
  }

  const fetcher = async (): Promise<GetOrdersResponseV1[]> => {
    const response = await client.bullyMiraklOrders(requestParameters)

    return response.data
  }

  return useSwr(
    shouldFetchOrders ? getSwrKey(commercialOrderIds) : null,
    fetcher,
  )
}
